import request from '@/utils/request'


export function getSelecotrData(source,param) {
  return request({
    url: `/api/selector?source=${source}&param=${param}`,
    method: 'get'
  })
}